import { COLOR } from '@src/styles/color';

export const variantMapping = {
  contained: {
    backgroundColor: COLOR.yellow.default,
    color: COLOR.darkBlue,
    padding: '12px 24px',
    borderRadius: '12px',
    boxSizing: 'border-box',
  },
  outlined: {
    backgroundColor: COLOR.white,
    color: COLOR.darkBlue,
    border: `1px solid ${COLOR.borderButtonCorlor}`,
    padding: '12px 24px',
    borderRadius: '12px',
    boxSizing: 'border-box',
  },
  outlineSmall: {
    backgroundColor: COLOR.white,
    color: COLOR.darkBlue,
    border: `1px solid ${COLOR.borderButtonCorlor}`,
    padding: '8px 12px',
    borderRadius: '12px',
    boxSizing: 'border-box',
  },
  containedSmall: {
    backgroundColor: COLOR.yellow.default,
    color: COLOR.darkBlue,
    padding: '8px 12px',
    borderRadius: '12px',
    boxSizing: 'border-box',
    border: `1px solid ${COLOR.darkV2[16]}`,
    textTransform: 'none',
  },
};
